import { milliToDate } from "../../../utils/commonUtil";

export default function apiDataFormatter(apiData) {
  let advisorData = [];
  advisorData.userId = apiData.webAccess.userName;

  let advisorInfo = [];
 
  let data = apiData.profileSummary;
  let phones = [];
  let emails = [];
  let addresses = [];

  if(data.phone != null){
    phones = data.phone.map(phone => {
      return {
        addressId: phone.addressId,
        phonetype: phone.phoneType,
        phonenumber: phone.phone,
        primary: phone.primary === 1 ? true : false
      };
    });  
  }else{
    phones = []
  }
  if (phones.length === 1) {
    phones[0]["primary"] = true;
  }

  if(data.email != null){
    emails = data.email.map(email => {
      return {
        addressId: email.addressId,
        emailId: email.email,
        emailtype: email.emailType,
        primary: email.primary === 1 ? true : false
      };
    });
  }else{
    emails = [];
  }
  if (emails.length === 1) {
    emails[0]["primary"] = true;
  }

  if(data.address != null){
    addresses = data.address.map(address => {
      return {
        addressId: address.addressId,
        addresstype: address.addressType,
        line1: address.addressLine1,
        line2: address.addressLine2,
        line3: address.addressLine3,
        city: address.city,
        state: address.state,
        zipcode: address.zipCode,
        country: address.country,
        primary: address.primary === 1 ? true : false
      };
    });
  }else{
    addresses = []
  }
  if (addresses.length === 1) {
    addresses[0]["primary"] = true;
  }

  let relatedDonor = data.relatedDonor ? data.relatedDonor : null;
  advisorInfo.push({
    primary: true,
    title: data.title,
    firstname: data.firstName,
    middlename: data.middleName,
    lastname: data.lastName,
    suffix: data.suffix,
    dob: (data.dateOfBirthStr !== "" && data.dateOfBirthStr) ? data.dateOfBirthStr : data.dob,
    gender: data.gender,
    ssn: data.ssn,
    phones: phones,
    emails: emails,
    addresses: addresses,
    deliveryMethod: data.deliveryPreference,
    relatedDonor: relatedDonor,
    role: apiData.webAccess.roles,
    userId: advisorData.userId,
    name: data.name
  });
  advisorData["advisors"] = advisorInfo;
  return advisorData;
}